import { Link } from "react-router-dom";
import ComicModel from "./../../../models/ComicModel";

export const SearchComic: React.FC<{ comic: ComicModel }> = (props) => {
    
	return (
		<div className="card mt-3 shadow p-3 mb-3 bg-body rounded">
			<div className="row g-0">
				<div className="col-md-2">
                    {/* Desktop Image */}
					<div className="d-none d-lg-flex justify-content-center align-items-center ">
						{props.comic.img ? (
							<img
								src={props.comic.img}
								width="123"
								height="196"
								className="extra-shadow mb-2"
							/>
						) : (
							<img
								src={require("../../../Images/CoverImages/notFound.png")}
							/>
						)}
					</div>

                    {/* Mobile Image */}

                    <div className="d-lg-none d-flex justify-content-center align-items-center">
						{props.comic.img ? (
							<img
								src={props.comic.img}
								width="123"
								height="196"
								className="extra-shadow mb-2"
							/>
						) : (
							<img
								src={require("../../../Images/CoverImages/notFound.png")}
							/>
						)}
					</div>
                    
                    <div className="me-2 d-flex justify-content-center align-items-center"> <p>Copies Available: <span className={props.comic.copiesAvailable <= 3 ? 'text-danger' : ''}>{props.comic.copiesAvailable}</span></p></div>
                    
				</div>
                <div className='col-md-8'>
                    <div className='card-body'>
                        <h3 className='card-title'>
                            {props.comic.title}
                        </h3>
                        <h6>
                            {props.comic.author + ' - Published: ' + props.comic.published + ' - Marvel Database ID: ' + props.comic.db_id}
                        </h6>
                        <p className='card-text'>
                            {props.comic.description}
                        </p>
                    </div>
                </div>
                <div className='col-md-2 d-flex justify-content-center align-items-center'>
                    <Link className='btn btn-medium btn-dark text-white' to={`checkout/${props.comic.id}`}>
                        View Details
                    </Link>
                </div>
			</div>
		</div>
	);
};
